import { computed } from 'vue';
import { DEFAULT_FEATURE_FLAGS, type FeatureFlags } from '@s-blog/shared-types';
import { useSiteConfig } from '@/composables/useSiteConfig';

/**
 * 前台功能开关 — 站长在后台关掉某些功能/彩蛋时, 前台据此隐藏入口。
 * config 未加载时回退全开 (DEFAULT_FEATURE_FLAGS) → 首屏不会闪掉本该显示的功能。
 * 关掉只隐藏前台入口, 后端 endpoint 保留 (数据回灌等仍可用)。
 */
export function useFeatureFlags() {
  const { config } = useSiteConfig();
  const features = computed<FeatureFlags>(() => config.value?.features ?? DEFAULT_FEATURE_FLAGS);
  return { features };
}
